import { useEffect } from 'react'
import { BASE_ASSET_URL } from 'flows/common/constants'
import { CREATION_GOAL_ASSETS } from 'flows/common/steps/FirstCreation/FirstCreation'

export const MARKETING_EXPERIENCE_ASSETS: Record<string, string> = {
  0: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image_pocxqb.png',
  1: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image-1_eyss18.png',
  2: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image-2_ylx1sm.png',
  3: 'https://res.cloudinary.com/almanac/image/upload/v1740090707/onboarding_assets/marketing_experience/image-3_gcejmt.png',
}

interface ImagePreloaderProps {
  urls: string[]
}

/**
 * Generic component that preloads an array of image URLs
 * by creating Image objects and setting their src
 */
export const ImagePreloader: React.FC<ImagePreloaderProps> = ({ urls }) => {
  useEffect(() => {
    urls.forEach((url) => {
      const img = new Image()
      img.src = url
    })
  }, [urls])

  return null
}

export const SiderImagePreloader = () => {
  const totalSteps = 17
  const imageIndexes = Array.from({ length: totalSteps }, (_, i) => {
    const stepToUse = i + 1 === 1 ? 1 : i
    return stepToUse
  })

  const uniqueImageIndexes = [...new Set(imageIndexes)]
  const imageUrls = uniqueImageIndexes.map((index) => `${BASE_ASSET_URL}/${index}.jpg`)

  return <ImagePreloader urls={imageUrls} />
}

const ALL_STEP_IMAGES = [...Object.values(MARKETING_EXPERIENCE_ASSETS), ...Object.values(CREATION_GOAL_ASSETS)]

export const StepImagePreloader = () => {
  return <ImagePreloader urls={ALL_STEP_IMAGES} />
}
